/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SimulatorApp_imageResult = {
    readonly identifiedStatus: string;
    readonly uuid: string;
    readonly image: {
        readonly threat: {
            readonly uuid: string;
        } | null;
    };
    readonly " $fragmentRefs": FragmentRefs<"SimulatorDisplay_imageResult">;
    readonly " $refType": "SimulatorApp_imageResult";
};
export type SimulatorApp_imageResult$data = SimulatorApp_imageResult;
export type SimulatorApp_imageResult$key = {
    readonly " $data"?: SimulatorApp_imageResult$data;
    readonly " $fragmentRefs": FragmentRefs<"SimulatorApp_imageResult">;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "uuid",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Fragment",
        "name": "SimulatorApp_imageResult",
        "type": "ImageResult",
        "metadata": null,
        "argumentDefinitions": [],
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "identifiedStatus",
                "args": null,
                "storageKey": null
            },
            (v0 /*: any*/),
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "image",
                "storageKey": null,
                "args": null,
                "concreteType": "PackagedImage",
                "plural": false,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "threat",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ThreatBundle",
                        "plural": false,
                        "selections": [
                            (v0 /*: any*/)
                        ]
                    }
                ]
            },
            {
                "kind": "FragmentSpread",
                "name": "SimulatorDisplay_imageResult",
                "args": null
            }
        ]
    } as any;
})();
(node as any).hash = '66d7297c0cb71e581f6e24d38b3c5b6d';
export default node;
